<script>
    import ContactFormElement from "../../components/pagesbuilder/elements/ContactFormElement";
    import PreviewElement from "./PreviewElement";
    import {mapActions} from "vuex";

    export default {
        name: "PreviewContactFormElement",
        mixins: [
            PreviewElement,
            ContactFormElement,
        ],
        data() {
            return {
                isSubmited: false
            }
        },
        methods: {
            ...mapActions('common', [
                'submitContactData'
            ]),
            addListeners() {
                this.elementNode.addEventListener('submit', (e) => {
                    e.preventDefault();
                    this.contactFormSubmitAction();
                })
            },

            contactFormSubmitAction() {
                let postData = {};

                // Find submit element. Can be either button or input with submit type
                const submit = Array.from(this.elementNode.elements).find( el => el.type === 'submit');
                submit.setAttribute('disabled', '');

                // Take tha values of every input and textarea elements
                this.elementNode.querySelectorAll('input, textarea').forEach((input) => {
                    if (input.hasAttribute('name')) {
                        const name = input.getAttribute('name');
                        postData[name] = input.value;
                    }
                });

                this.submitContactData(postData)
                    .then((response) => {
                        if (response.data.success) {
                            this.notifyWrapperForSubmission();
                        } else {
                            displayError(response.data.errors);
                        }
                        submit.removeAttribute('disabled');
                    })
                    .catch((err) => {
                        console.log(err);
                        submit.removeAttribute('disabled');
                    })
            },

            notifyWrapperForSubmission() {
                const wrapper = this.elementNode.closest("[data-node-type='contact-form-wrapper']");
                const wrapperState = this.findNodeState(wrapper.id);
                wrapperState.setFormStatus('submitted');
            }
        }
    }
</script>
